import React, { useContext, useState, useEffect } from 'react'
// import { auth, isUserAdmin } from './firebase'
import { auth } from './firebase'

const AuthContext = React.createContext()

export function useAuth () {
  return useContext(AuthContext)
}

export function AuthProvider ({ children }) {
  const [currentUser, setCurrentUser] = useState()
  const [loading, setLoading] = useState(true)

  // Function to sign up with Firebase
  function signup (email, password, name) {
    return auth.createUserWithEmailAndPassword(email, password)
  }
  // Function to update user profile
  function updateProfile (name) {
    auth.onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        return auth.currentUser.updateProfile({
          displayName: name
        })
      } else {
        // No user is signed in.
        return console.log('no user is signed in')
      }
    })
  }
  // Function to login with Firebase
  function login (email, password) {
    return auth.signInWithEmailAndPassword(email, password)
  }

  // Function to logout with Firebase
  function logout () {
    return auth.signOut()
  }

  // Rest Password in Firebase
  function resetPassword (email) {
    const actionCodeSettings = {
      // After password reset, the user will be give the ability to go back
      // to this page.
      url: 'https://taito-training.web.app/login',
      handleCodeInApp: false
    }
    return auth.sendPasswordResetEmail(email, actionCodeSettings)
  }

  // Function to update/change user email in Firebase
  function updateEmail (email) {
    return currentUser.updateEmail(email)
  }

  // function to update/change login password in Firebase
  function updatePassword (password) {
    return currentUser.updatePassword(password)
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user)
      setLoading(false)
    })
    return function cleanup () {
      setLoading(true) && unsubscribe()
    }
  }, [currentUser])

  const value = {
    currentUser,
    signup,
    updateProfile,
    login,
    logout,
    resetPassword,
    updateEmail,
    updatePassword
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
